import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import { LoadingIndicator } from 'common/components/preloader';
import Pager from 'common/containers/pager';
import PaymentRow from 'account/components/payout/payment_row';
import PaymentAwards from 'account/components/payout/payment_awards';

/**
 * Payments table.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class PaymentsTable extends Component {
  constructor(props) {
    super(props);

    this.state = { expandedIdx: null };

    this.toggleExpand = this.toggleExpand.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.props.fetch();
  }

  toggleExpand(idx) {
    this.setState({ expandedIdx: idx === this.state.expandedIdx? null : idx });
  }

  handlePageChange(page) {
    /* close expanded item on page change */
    this.setState({ expandedIdx: null });
    this.props.updatePage(page);
  }

  renderItem(item, idx) {
    const className = idx % 2 === 0? 'even' : 'odd';
    return (
      <PaymentRow key={idx} item={item} type={this.props.type} className={className}
        expanded={idx == this.state.expandedIdx}
        onExpand={partial(this.toggleExpand, idx)}/>
    )
  }

  render() {
    const { items, type, currentPage, pageCount, atAdmin } = this.props;

    let emptyMessage;

    if (type === 'requested') {
      emptyMessage = (
        atAdmin? "No requested payments." : "You don't have any requested payments right now."
      );
    } else {
      emptyMessage = (
        atAdmin? "No issued payments." : "When payments are issued, they'll show here."
      );
    }

    /* fetching */
    if (!items) {
      return <LoadingIndicator fullScreen={false} />
    }

    /* empty list */
    if (items.length === 0) {
      return (
        <div className="empty-state no-results">
          <div className="empty-state-content">
            <h3>{ emptyMessage }</h3>
          </div>
        </div>)
    }

    const { expandedIdx } = this.state;
    /* items before <PaymentAwards/> */
    const beforeAwards = expandedIdx === null? items : items.slice(0, expandedIdx + 1);
    /* items after <PaymentAwards/> */
    const afterAwards = expandedIdx === null? [] : items.slice(expandedIdx + 1);
    /* <PaymentAwards /> must have the same className of the preceding row,
       as they are seen as one from the UI perspective. */
    const awardsClass = (beforeAwards.length - 1) % 2 === 0? 'even' : 'odd';

    return (
      <div className="payments-table">
        <table className="table table-default actionable">
          <thead>
            <tr>
              <td>Amount</td>
              <td>{type == 'requested'? 'Requested' : 'Date'}</td>
              <td className="hide-for-small-only">Account</td>
              <td>Awards</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody>
            {beforeAwards.map((item, i) => this.renderItem(item, i))}

            {expandedIdx !== null &&
            <PaymentAwards className={awardsClass} item={items[expandedIdx]} type={type}
              atAdmin={atAdmin} />}

            {afterAwards.map((item, j) => {
              const i = beforeAwards.length + j;
              return this.renderItem(item, i);
            })}
          </tbody>
        </table>

        {type == 'history' && pageCount > 1 &&
        <Pager formName="payout_history" onPageChange={this.handlePageChange}
          pageCount={pageCount} currentPage={currentPage} />}

      </div>);
  }
};

PaymentsTable.propTypes = {
  items: PropTypes.array,
  type: PropTypes.string,
  fetch: PropTypes.func,
  currentPage: PropTypes.number,
  pageCount: PropTypes.number,
  updatePage: PropTypes.func,
  atAdmin: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./account/components/payout/payments_table.jsx